const isAuthenticated = () => !!localStorage.doctorToken;

export default isAuthenticated;
